module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_9016.377c37a9.png";